import { Autocomplete, styled } from '@mui/material';

export const StyledGradeBookMonthAutocomplete = styled(Autocomplete)({
	flex: 1,
	minWidth: '220px',
	'& .MuiInputBase-root': { paddingBlock: '6px' },
});
